import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { getSnackbarSuccess, MandatoryStar } from "../../Utils/helper";
import { GetInsurerPayoutCountsNetwork, GetTotalAppointmentAction, GetTotalBillingDataAction, MoveToBillingAction, removeBillingAction } from "../../redux/actions/InsBillAction";

export const MoveToBilling = ({
  searchFilter,
  setMoveToBilling,
  providerDetail,
  setProviderDetail,
  openModel,
  setOpenModel
}) => {
  const ref = useRef();
  const [remark, setRemark] = useState(null);
  const dispatch = useDispatch();
    console.log("first",providerDetail)
  const handleSubmit = async (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    if (event.target.checkValidity()) {
      const res = await dispatch(
        MoveToBillingAction({
          appointmentId: providerDetail[0]?.appointmentId,
          clientId: providerDetail[0]?.clientId,
          remarks: remark,
        })
      );
      if (res) {
        getSnackbarSuccess("success", res?.data?.message, dispatch);
        setTimeout(() => {
          dispatch(
            GetTotalBillingDataAction({
              ...searchFilter,
              page: 1,
              rows: 10,
            })
          );
          dispatch(GetInsurerPayoutCountsNetwork(searchFilter));
        }, 2000);
        
        handleClose();
      }
    }
  };

  const handleClose = () => {
    setOpenModel({...openModel,moveToBilling :false})
    setProviderDetail([])
  };
  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black ">Move To Billing</h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={() => handleClose()}
        ></button>
      </div>

      <form
        ref={ref}
        className="form-admin"
        style={{ overflowX: "hidden" }}
        onSubmit={handleSubmit}
        noValidate
      >
        <div className="modal-body addusermodalbox">
          <div className="row">
            <div className="col-lg-12 col-md-12 mt-2">
                <div style={{fontWeight:"600"}}>Case Number : {providerDetail[0]?.caseNo}</div>
              <label className="col-form-label">
                Remarks
                <MandatoryStar />
              </label>
              <textarea
                required
                className="form-control form-select-admin inputbgavanish"
                rows="5"
                cols="33"
                value={remark}
                onKeyPress={(e) => {
                  const re = /^[a-zA-Z\s]*$/;
                  if (e.target.value.trim() === "" && e.key === " ") {
                    e.preventDefault();
                    return;
                  }
                }}
                onChange={(e) => setRemark(e.target.value)}
              ></textarea>
            </div>
          </div>
        </div>

        <div className="modal-footer modal-footer-admin  bottom-0  mt-4">
          <div className="d-flex justify-content-end flex-wrap gap-10">
            <button
              onClick={() => handleClose()}
              type="btn"
              className="savedetails"
            >
              Cancel
            </button>
            <button type="submit" className="savedetails">
              {"Update"}
            </button>
          </div>
        </div>
      </form>
    </>
  );
};
